import React from "react";
import { Input, Button, Tooltip, Table, DatePicker, Popconfirm, message } from "antd";

import locale from 'antd/es/date-picker/locale/zh_CN';
import { SearchOutlined } from '@ant-design/icons';
import ClassifyEditor from './com/classifyEditor'
import './index.sass'
import api from "../../utils/api";
import UserInfo from "../../components/UserInfo";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";

class GoodsClassify extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showClassify: {},
            dataSource: [],
            totalD: null
        }
    }


    componentDidMount() {
        this.getSumPro();
        this.getClassify();
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.getSumPro();
            this.getClassify();
        }
        return true;
    }

    show_classify = (val) => {
        this.setState({
            showClassify: val
        })
    }

    getSumPro = async () => {
        let res = await api('sum-product-by-merchant');
        if (res.code === 200) {
            this.setState({
                totalD: res.data
            })
        }
    }

    delClassify = async (ctx) => {
        await ctx
        let param = {
            cate_ids: [ctx.id]
        }

        let res = await api('del-cates', param);
        if (res.code === 200) { message.success('删除成功！'); this.getClassify() } else { message.error(res.config.message) }
    }

    editorClassify = (ctx) => {
    }


    getClassify = async () => {//获取商品分类
        let res = await api('get-cates');
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
        console.log(res)
    }

    render() {
        let { showClassify, dataSource, totalD } = this.state

        const columns = [
            {
                title: '分类名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '创建时间',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex alignCenter contrl'>
                            <Button className='mgr10' type='primary' size='small' onClick={() => {
                                //this.editorClassify(ctx)
                                this.show_classify({ show: true, type: 'changeCLassify', item: ctx })
                            }}>编辑</Button>

                            <Popconfirm
                                title="确认删除此分类?"
                                onConfirm={() => {
                                    this.delClassify(ctx)
                                }}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Button danger size='small' onClick={() => {
                                    //this.delClassify(ctx)
                                    this.show_classify({ show: false, type: 'delCLassify', item: ctx })
                                }}>删除</Button>
                            </Popconfirm>

                        </div>
                    )
                }
            },
        ];
        return (
            <div className='goodsClassify'>
                {/* 头部 */}
                {
                    totalD ? (<UserInfo rightBox={<ul className='flex census'>
                        <li>
                            <label>全部商品</label>
                            <p>{totalD.product_num}</p>
                        </li>
                        <li>
                            <label>全部商品分类</label>
                            <p>{totalD.cate_num}</p>
                        </li>
                    </ul>} />) : null
                }

                <div className='record'>

                    <div className='change_fans flex' style={{ justifyContent: 'space-between' }}>

                        <div className='flex line alignCenter'>
                            搜索分类：
                            <Input placeholder='搜索昵称：' />
                            <Button icon={<SearchOutlined />}>搜索</Button>

                            <Button>重置</Button>
                        </div>

                        <Button onClick={() => { this.show_classify({ show: true, type: 'newCLassify', item: null }) }} className='themeBtn'>新建分类</Button>

                    </div>


                    <div className='change_fans'>
                        <Table dataSource={dataSource} columns={columns} />
                    </div>


                </div>

                {
                    showClassify && showClassify.show ? (
                        <ClassifyEditor update={() => { this.getClassify() }} showClassify={showClassify} colsePop={(e) => { this.show_classify(e) }} />
                    ) : null
                }
            </div>
        )
    }
}


const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(GoodsClassify);